/** Side of a node to attach a link/transition to. */
export enum PortSide {
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  top = 'top'
}
